import type { CallIntroStep } from "@expert/sales-tools";

import { CustomerVerificationStep } from "@expert/sales-tools";

import type { IVRInfo } from "@/sdk";

export function isIVRHandoffStep({
    callIntroStep,
    stepHistory,
    isEnhancedCustomerSearchEnabled,
    ivrInfo,
}: {
    callIntroStep: CallIntroStep;
    stepHistory: CustomerVerificationStep[];
    isEnhancedCustomerSearchEnabled: boolean;
    ivrInfo?: IVRInfo;
}) {
    const isSaasIVRHandoffStep = isEnhancedCustomerSearchEnabled && callIntroStep === "CustomerInfoCollection";
    const isStandardIVRHandoffStep =
        !isEnhancedCustomerSearchEnabled && stepHistory.at(stepHistory.length - 1) === "CustomerPhoneInput";
    const isConversationalIVRHandoffStep =
        !!ivrInfo?.conversationalSummary && stepHistory.at(stepHistory.length - 1) === "CustomerHandoff";
    return (
        (isSaasIVRHandoffStep && !!ivrInfo?.intent) ||
        (isStandardIVRHandoffStep && hasStandardIVRInfo(ivrInfo)) ||
        isConversationalIVRHandoffStep
    );
}

export function hasStandardIVRInfo({
    intent,
    device,
    summary,
    productLink,
    conversationalSummary,
}: IVRInfo = {}): boolean {
    return (!!intent || !!device || !!summary || !!productLink) && !conversationalSummary;
}
